import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TopWinnersService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) { }

  getTopWinners() {
    let dateTime = new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd')
    const url = environment.apiUrl + `/bets/dailyTopCoupons`;

    const topWinners = this.http.post<any>(url, {
      date: dateTime
    }, this.httpOptions)

    return topWinners;
  }
}
